import { TenderStatus } from '@modules/tender-platform/types';

export const TENDER_FILTER_FOR_CARRIER: Array<TenderStatus> = [TenderStatus.Cancelled, TenderStatus.NotTake];

export const TENDER_ENDED_STATUSES: Array<any> = [TenderStatus.Completed, TenderStatus.Executed, TenderStatus.Cancelled];

export const NOT_TENDER_CHANGE_STATUSES = [TenderStatus.Completed, TenderStatus.Cancelled, TenderStatus.NotTake, TenderStatus.Executed];
